<template>
  <div>
    <b-container fluid class="tw-mb-5 tw-bg-gray-100 tw-border tw-border-blue-200" style="padding-bottom: 10px;">
      <b-row>
        <!-- BEGIN CHART -->
        <b-col md="12" lg="10" :xl="9" class="tw-overflow-x-scroll" ref="clusterEnrollmentChartContainer">
          <bar-chart
            v-if="loaded"
            :chartData="clusterEnrollment.chartdata"
            :options="clusterEnrollment.options"
            :styles="clusterEnrollment.myStyles"
          >
          </bar-chart>
          <span class="text-secondary tw-text-xs text-center" v-if="last_update">Last Updated: {{last_update}}</span>
        </b-col>
        <!-- END CHART -->
        <!-- BEGIN CARDS -->
        <b-col md="12" lg="2" :xl=3>
          <b-container>
            <b-row>
              <b-col lg="12" :xl=10 class="tw-p-1">
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Total {{ capitalize(category) }} Compound Members Enrolled
                    </h6>
                    <h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">
                      {{ totalCompoundMembersEnrolled }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      <!-- END CARDS -->
    </b-row>
      <b-row>
        <b-col>
          <div class="tw-mt-auto tw-flex tw-justify-end">
            <info-popover>
              <template v-slot:title>
                Cluster Febrile Enrollment
              </template>
              <p>For each cluster, show how many compound members are enrolled / consented, and which have met the targets.</p>
            </info-popover>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import * as _ from "lodash";

import moment from 'moment-timezone';

import BarChart from "@/components/charts/BarChart.vue";

export default {
  mixins: [],
  components: {
    BarChart,
  },
  props: {},
  data() {
    return {
      loaded: false,
      last_update: null,
      category: 'febrile',
      categoryOptions: [
        {value: 'ento', text: 'Aspirations'},
        // {value: 'febrile', text: 'Febrile Surveillance'},
        // {value: 'longitudinal', text: 'Longitudinal Participants'},
        {value: 'product', text: 'Product Placement'},
      ],
      totalCompoundMembersEnrolled: 0,
      totalHouseholdsConsented: 0,
      enrollmentTarget: 130,
      clusterReachedEnrollmentTarget: 0,
      clusterEnrollment: {
        chartdata: {
          datasets: [
            {
              label: "Enrollment",
              backgroundColor: "red",
              data: [45, 23],
            },
            {
              label: "Consented",
              backgroundColor: "green",
              data: [42, 20],
            },
          ],
          labels: [1, 2],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18,
            },
          },
          title: {
            display: true,
            text: "Cluster Febrile Enrollment Progress",
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
          scales: {
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Cluster",
                },
              },
            ],
            yAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Compound Members",
                },
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
        myStyles: {
          height: "35vh",
          width: "150vh",
          position: "relative",
        },
      },
    };
  },
  computed: {},
  watch: {
    category: function() {
      this.get();
    },
  },
  created: function() {
    HTTP.get("/lib/get_last_updated_at/update_cluster_enrollment", {})
      .then((response) => {
        this.last_update = moment(response.data['last_update']).tz(moment.tz.guess());
      })
  },
  mounted: function() {
  this.get();
  },
  methods: {
    capitalize: function(value){
        return _.capitalize(value);
    },
    get: function() {
      let datasets = [];

      datasets = [
        // {
        //   label: "Consented",
        //   backgroundColor: "#37B1CA",
        //   data: [],
        // },
        {
          label: "Enrolled",
          backgroundColor: "#37B1CA",
          data: [],
        },
      ];

      let labels = [];
      let cluster = {};
      let cluster_number = '';

      const that = this;
      HTTP.get("/srilanka/metrics/cluster-enrollment", {params: {category: that.category}})
        .then((response) => {
          that.totalCompoundMembersEnrolled = 0;
          that.clusterReachedEnrollmentTarget = 0;
          _.each(response.data, function(item) {
            cluster_number = item.cluster_id.split("r")[1];
            cluster[cluster_number] = item;
          });

          for (let x = 1; x <= 30; x++) {
            if (x in cluster) {  // of there are counts to show
              // enrolled
              datasets[0].data.push(cluster[x]['current_enrollment_count']);
              that.totalCompoundMembersEnrolled += cluster[x]['current_enrollment_count'];

              // consented
              // datasets[0].data.push(cluster[x]['current_consented_count']);
              // that.totalHouseholdsConsented += cluster[x]['current_enrollment_count'];

              // is the cluster fully erolled?
              if (cluster[x]['current_enrollment_count'] >= that.enrollmentTarget) {
                that.clusterReachedEnrollmentTarget += 1;
              }
            } else {  // nothing to count
              datasets[0].data.push(0);
              // datasets[1].data.push(0);
            }
            labels.push(x);

            // datasets[2].data.push(that.enrollmentTarget);
            // datasets[3].data.push(that.consentTarget);
          }

          that.clusterEnrollment.chartdata = {
              datasets: datasets,
              labels: labels
          };

          that.loaded = true;

          // setTimeout(function() {
          //   that.$refs['clusterEnrollmentChartContainer'].scrollLeft = that.$refs['clusterEnrollmentChartContainer'].scrollWidth / 3.5;
          // }, 500);
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {},
  },
};
</script>

<style>

/* #bar-chart {
  height: 240px !important;
} */
</style>
